const positive = (v) => typeof v === 'number' && Number.isFinite(v) && v > 0;
/** Shared boundary for the ticket and the authenticated command surface. */
export function validatePremiumOrder(raw, side) {
    if (!raw || typeof raw !== 'object' || Array.isArray(raw))
        return 'Set an entry limit price.';
    const value = raw;
    if (!positive(value.limitPrice))
        return 'Set a positive entry limit price.';
    for (const [name, price, below] of [
        ['Stop loss', value.stopLoss, side === 'BUY'], ['Target', value.target, side === 'SELL'],
    ]) {
        if (price == null)
            continue;
        if (!positive(price))
            return `${name} must be a positive price.`;
        if (below ? price >= value.limitPrice : price <= value.limitPrice)
            return `${name} must be ${below ? 'below' : 'above'} the entry limit.`;
    }
    return null;
}
/** Fixed leg limits preserve the combined cap even if the legs fill apart. */
export function premiumEntryLimits(side, limit, quotes, now) {
    if (!positive(limit) || quotes.length < 1 || quotes.length > 2)
        return null;
    if (quotes.some((q) => !positive(q.bid) || !positive(q.ask) || q.bid > q.ask || !positive(q.tickSize) || !Number.isFinite(q.at) || now - q.at > 3000 || q.at > now + 1000))
        return null;
    const prices = quotes.map((q) => {
        const touch = side === 'BUY' ? q.ask : q.bid;
        return Number(((side === 'BUY' ? Math.ceil(touch / q.tickSize - 1e-8) : Math.floor(touch / q.tickSize + 1e-8)) * q.tickSize).toFixed(4));
    });
    const sum = prices.reduce((a, b) => a + b, 0);
    if (side === 'BUY' ? sum > limit + 1e-8 : sum < limit - 1e-8)
        return null;
    const last = quotes.length - 1;
    const budget = limit - prices.slice(0, last).reduce((a, b) => a + b, 0);
    const tick = quotes[last].tickSize;
    prices[last] = Number(((side === 'BUY' ? Math.floor(budget / tick + 1e-8) : Math.ceil(budget / tick - 1e-8)) * tick).toFixed(4));
    return prices.every(positive) ? prices : null;
}
export function readPremiumProtection(raw) {
    if (!raw || typeof raw !== 'object' || Array.isArray(raw))
        return null;
    const p = raw;
    if (p.side !== 'BUY' && p.side !== 'SELL')
        return null;
    if (!(p.stopLoss == null || positive(p.stopLoss)) || !(p.target == null || positive(p.target)))
        return null;
    if (!Array.isArray(p.legs) || p.legs.length < 1 || p.legs.length > 2 || p.legs.some((l) => !l || typeof l.id !== 'string' || !Number.isInteger(l.qty) || l.qty <= 0))
        return null;
    if (new Set(p.legs.map((leg) => leg.id)).size !== p.legs.length || (p.stopLoss == null && p.target == null))
        return null;
    return { side: p.side, stopLoss: p.stopLoss ?? null, target: p.target ?? null, legs: p.legs, ...(typeof p.pausedReason === 'string' ? { pausedReason: p.pausedReason } : {}), ...(typeof p.exitIntentId === 'string' ? { exitIntentId: p.exitIntentId } : {}) };
}
//# sourceMappingURL=premiumOrder.js.map